/**
 * Drawer forms are tall and only the body scrolls, so a required field can sit far
 * outside the visible area. Without this, pressing Save looks like nothing happened
 * even though the inline message rendered below the offending input.
 *
 * Fields opt in by tagging their wrapper with `data-field="<name>"`.
 */
export const scrollToFirstError = (fieldNames) => {
  const names = Array.isArray(fieldNames) ? fieldNames : Object.keys(fieldNames || {});
  if (!names.length) return;

  window.requestAnimationFrame(() => {
    for (const name of names) {
      const wrapper = document.querySelector(`[data-field="${name}"]`);
      if (!wrapper) continue;
      wrapper.scrollIntoView({ behavior: "smooth", block: "center" });
      wrapper.querySelector("input, textarea, select")?.focus({ preventScroll: true });
      return;
    }
  });
};

export const errorSummary = (count) =>
  count === 1
    ? "1 field needs your attention before saving."
    : `${count} fields need your attention before saving.`;
